module.exports = __webpack_public_path__ + "img/Logo-9.5e7f6190.svg";